import React, { Fragment, useState } from "react";
import TopLine from "../common/TopLine";
import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";
import uniqid from "uniqid";
import Row from "../common/List/Row";
import { getRentDate } from "../../functions/formatTime";
import ChakraPopUp from "../common/PopUp/ChakraPopUp";
import {
  Divider,
  Flex,
  FormLabel,
  HStack,
  Input,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import color from "../../config/color";
import { useFormik } from "formik";
import { fetchWithToken } from "../../functions/fetch";
import { useQueryClient } from "@tanstack/react-query";
import { updateRoomSchema } from "../../validation/roomValidation";
import ErrorMessages from "../common/PopUp/ChakraFormik/ErrorMessages";
import { Checkbox } from "@chakra-ui/react";

const RoomList = ({ rooms }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editingRoom, setEditingRoom] = useState(null);

  const titles = [
    "房型",
    "樓層",
    "房號",
    "租金",
    "租賃人數",
    "會員編號",
    "住戶姓名",
    "聯絡電話",
    "租期",
    "隱藏",
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();

  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: {
      cost: editingRoom?.cost ?? "",
      hidden: editingRoom?.hidden ?? false,
    },
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);

        const { cost, hidden } = values;
        console.log(hidden);
        const body = {
          cost,
          hidden,
        };

        const res = await fetchWithToken(
          "PUT",
          `${process.env.REACT_APP_BACKEND_HOST}/api/room/${editingRoom._id}`,
          body,
        );
        if (res.status !== 200) {
          console.error(res);
        }
        queryClient.invalidateQueries({ queryKey: ["rooms"] });

        setIsSubmitting(false);
        onClose();
      } catch (err) {
        console.error(err);
      }
    },
    enableReinitialize: true,
    validationSchema: updateRoomSchema,
  });

  return (
    <div>
      <TopLine />
      {/* Edit room pop up */}
      <ChakraPopUp
        isOpen={isOpen}
        onClose={onClose}
        isSubmitting={isSubmitting}
        title="編輯房間"
        onSubmit={formik.handleSubmit}
      >
        <Flex flexDirection="column" gap={2}>
          <Text>房型： {editingRoom?.roomType}</Text>
          <Text>樓層： {editingRoom?.floor}</Text>
          <HStack>
            <FormLabel whiteSpace="nowrap" my={0} htmlFor="cost">
              租金：
            </FormLabel>
            <Input
              type="number"
              variant="filled"
              w="auto"
              {...formik.getFieldProps("cost")}
            />
          </HStack>
          <Text>租賃人數： {editingRoom?.renters?.length ?? 0}</Text>
          <HStack>
            <Checkbox
              defaultChecked={editingRoom?.hidden}
              {...formik.getFieldProps("hidden")}
            >
              隱藏房間
            </Checkbox>
          </HStack>
          {editingRoom?.renters &&
            editingRoom.renters.map((renter) => (
              <Fragment key={uniqid()}>
                <Divider borderColor={color.orange} />
                <Text>會員編號： {renter.memberNumber ?? "無"}</Text>
                <Text>住戶： {renter.name ?? "無"}</Text>
                <Text>聯絡電話： {renter.phoneNumber ?? "無"}</Text>
                <Text>
                  租期：{" "}
                  {getRentDate(
                    editingRoom?.rentStartDate,
                    editingRoom?.rentEndDate,
                  ) || "無"}
                </Text>
              </Fragment>
            ))}
          <ErrorMessages formik={formik} />
        </Flex>
      </ChakraPopUp>
      <List gridCols="grid-cols-[repeat(10,minmax(min-content,1fr))]">
        {titles.map((title) => (
          <TitleCell
            key={uniqid()}
            className="whitespace-nowrap px-2 overflow-x-auto"
            text={title}
          />
        ))}
        {rooms.map((room) => {
          const { roomType, floor, roomNumber, renters, cost, hidden } = room;
          const names = renters
            ? renters.map((renter) => renter.name).join(",")
            : "";
          const cellTexts = [
            roomType,
            floor,
            roomNumber,
            cost,
            room.renters?.length ?? 0,
            renters ? renters[0]?.memberNumber : "", // take the first renter
            names,
            renters ? renters[0]?.phoneNumber : "",
            getRentDate(room.rentStartDate, room.rentEndDate),
            hidden ? "✅" : "",
          ];

          const cellAlign = ["C", "C", "C", "C", "C", "C", "C", "C", "C", "C"];

          const showPopUp = () => {
            setEditingRoom(room);
            onOpen();
          };

          return (
            <Row
              key={uniqid()}
              cellTexts={cellTexts}
              noteTexts={[]}
              showPopUp={showPopUp}
              cellAlign={cellAlign}
            />
          );
        })}
      </List>
    </div>
  );
};

export default RoomList;
